import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RequestStatus } from "@app/constants";
import { IRequestFailed } from "@app/types";
import { IModelState } from "./types";

const initialState: IModelState = {
  model: {},
  addModel: {},
  deleteModel: {},
  updateModel: {},
};

const slice = createSlice({
  name: "model",
  initialState,
  reducers: {
    model(state) {
      state.model.status = RequestStatus.RUNNING;
    },
    modelSuccess(state, action) {
      state.model.status = RequestStatus.SUCCESS;
      state.model.data = action.payload;
    },
    modelFailed(state, action: PayloadAction<IRequestFailed>) {
      state.model.status = RequestStatus.ERROR;
      state.model.error = action.payload;
    },
    addModel(state, action) {
      state.addModel.status = RequestStatus.RUNNING;
    },
    addModelSuccess(state, action) {
      state.addModel.status = RequestStatus.SUCCESS;
      state.addModel.data = action.payload;
    },
    addModelFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addModel.status = RequestStatus.ERROR;
      state.addModel.error = action.payload;
    },
    //
    updateModel(state, action) {
      state.updateModel.status = RequestStatus.RUNNING;
    },
    updateModelSuccess(state, action) {
      state.updateModel.status = RequestStatus.SUCCESS;
      state.updateModel.data = action.payload;
    },
    updateModelFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateModel.status = RequestStatus.ERROR;
      state.updateModel.error = action.payload;
    },
    //
    deleteModel(state, action: PayloadAction<{ modelId: number }>) {
      state.deleteModel.status = RequestStatus.RUNNING;
    },
    deleteModelSuccess(state, action) {
      state.deleteModel.status = RequestStatus.SUCCESS;
      state.deleteModel.data = action.payload;
    },
    deleteModelFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteModel.status = RequestStatus.ERROR;
      state.deleteModel.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  model,
  modelSuccess,
  modelFailed,
  addModel,
  addModelSuccess,
  addModelFailed,
  deleteModel,
  deleteModelFailed,
  deleteModelSuccess,
  updateModel,
  updateModelFailed,
  updateModelSuccess,
} = slice.actions;
